"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inject = void 0;
var react_1 = require("react");
var DependencyContainerReactContext_1 = require("./DependencyContainerReactContext");
var Inject = /** @class */ (function (_super) {
    __extends(Inject, _super);
    function Inject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { value: null };
        return _this;
    }
    Inject.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, diKey = _a.diKey, diKeys = _a.diKeys, autoRegister = _a.autoRegister;
        if (!diKey && !diKeys) {
            throw new Error('You must provide either a diKey prop or a diKeys prop to Inject');
        }
        // Always use an array so that values are passed as arguments to props.children
        var keysToInject = diKeys ? diKeys : [diKey];
        if (autoRegister) {
            keysToInject.forEach(function (key) { return _this.context.container.autoRegister(key); });
        }
        var value = keysToInject.map(function (key) { return _this.context.container.get(key); });
        this.setState({ value: value });
    };
    Inject.prototype.render = function () {
        var _a;
        var value = this.state.value;
        if (!value) {
            return null;
        }
        return (_a = this.props).children.apply(_a, value);
    };
    Inject.contextType = DependencyContainerReactContext_1.DependencyContainerReactContext;
    return Inject;
}(react_1.Component));
exports.Inject = Inject;
//# sourceMappingURL=Inject.js.map